/**
 * Zod-free on purpose: apps/aient-app/src/lib/env.ts imports this, and env.ts is in every client bundle,
 * so importing it from index.ts (which builds schemas at module load) shipped zod to every page.
 */
export function resolveMcpConnectionCommandDigestKeys(input: {
  configuredValue: string | undefined
  fallbackKey: string | undefined
  production: boolean
}): string[] {
  const source = input.configuredValue?.trim()
    ? input.configuredValue
    : input.production
      ? ''
      : input.fallbackKey ?? ''
  return [...new Set(source
    .split(',')
    .map(key => key.trim())
    .filter(Boolean))]
}
